import React, { useEffect, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import { useTranslations } from 'next-intl';

import useTimeout from '../../../hooks/useTimeout';

import Copy from '../../atoms/copy/copy';
import CloseIcon from '../../icons/close.svg';
import LongArrowRight from '../../icons/longArrowRight.svg';

import Question from './components/question/question';
import Flash from './components/flash/flash';

import StyledRoomOfQuestions from './roomOfQuestions.style';

import RoomOfQuestionsProvider, {
  RoomOfQuestionsContext
} from './contexts/roomOfQuestionsProvider';

const RoomOfQuestions = ({ isOpen = false, onClose = () => {} }) => {
  const t = useTranslations();
  const { currentQuestions, currentFlashes, removeQuestion, removeFlash } =
    useContext(RoomOfQuestionsContext);
  const [skipLinkVisible, setSkipLinkVisible] = useState(false);

  useEffect(() => {
    ReactModal.setAppElement(document.body);
  }, []);

  useTimeout(() => setSkipLinkVisible(true), 5000);

  return (
    <StyledRoomOfQuestions isOpen={isOpen} ariaHideApp={false} closeTimeoutMS={400}>
      <button
        className="roomOfQuestions__close"
        type="button"
        onClick={onClose}
        aria-label={t('roomOfQuestions.close')}
      >
        <CloseIcon />
      </button>

      <div className="roomOfQuestions__inner-content">
        {currentQuestions.map((item, index) => (
          <div
            key={item.id}
            style={{
              gridRow: `${item.row} / span 1`,
              gridColumn: '1 / span 1'
            }}
          >
            <Question question={item.question} onAnimationEnd={() => removeQuestion(index)} />
          </div>
        ))}

        {currentFlashes.map((item, index) => (
          <div
            key={item.row}
            style={{
              gridRow: `${item.row} / span 1`,
              gridColumn: '1 / span 1'
            }}
          >
            <Flash delay={item.delay} onAnimationEnd={() => removeFlash(index)} />
          </div>
        ))}
      </div>

      <button
        type="button"
        onClick={onClose}
        className="roomOfQuestions__skip"
        style={{ opacity: skipLinkVisible ? 1 : 0 }}
      >
        <LongArrowRight width="60px" height="20px" />
        <Copy thick noMargin>
          {t('roomOfQuestions.close')}
        </Copy>
      </button>

      <div className="roomOfQuestions__progress" onAnimationEnd={onClose} />
    </StyledRoomOfQuestions>
  );
};

RoomOfQuestions.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func
};

const RoomOfQuestionsComponent = RoomOfQuestions;

export default ({ questions, isOpen, onClose }) => (
  <RoomOfQuestionsProvider questions={questions}>
    <RoomOfQuestionsComponent isOpen={isOpen} onClose={onClose} />
  </RoomOfQuestionsProvider>
);
